"use strict";

module.exports = function () {
  return this.opts.filterable && this.opts.filterable.length ? this.opts.filterable : this.Columns;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/computed/filterable-columns.js
// module id = 2563
// module chunks = 0